<template>
    <span>
        <template v-if="type === 'pickup_point_subcustomer'">
            <template v-if="online">
                Commande click & collect
            </template>
            <template v-else>
                Commande manuelle
            </template>
        </template>
        <template v-else-if="type === 'store'">
            Commande magasin
        </template>
        <template v-else-if="type === 'short_channel'">
            Commande circuit court
        </template>
        <template v-else-if="type === 'customer_group'">
            Commande groupement de clients
        </template>
        <template v-else-if="type === 'pickup_point'">
            Fabrication pour un lieu de retrait
        </template>
        <template v-else>
            Commande de type inconnu
        </template>
    </span>
</template>

<script>
    export default {
        name: 'OrderTypeName',

        props: {
            type: {
                type: String,
                required: true,
            },
            online: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
    }
</script>

<style scoped>

</style>
